// extracted by mini-css-extract-plugin
export default {"container":"cc_g","icon":"cc_js","iconTick":"cc_jt","title":"cc_cX","subtitle":"cc_jv"};